import React, { useState, useEffect } from 'react';
import useApi from '../utils/UseAPI';
// import dataDates from "../data/data.json";
// React loading spinner
import Spinner from 'react-bootstrap/Spinner';
import Links from './Links';


const WIDScrollDown = ({year, linktypeId}) => {

    const yearsWithAddedOnFiles = ["2025"]


    // const [selected, setSelected] = useState(null);
    const [content, setContent] = useState([]);
    const { processing, error, getRequest } = useApi();
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        const fetchLinks = async () => {
            const [data, status] = await getRequest(null, `link/${linktypeId}`);
            if (status == 200) {
                setContent(data.data.sort((a, b) => a.sort - b.sort));
                // console.log(content)
            }
            else {
                console.log(error);
            }
        };
        fetchLinks();
    }, []);
    return (
        <>
            <div title='Select a date' className="col-md-4 col-md-3">
                {/* Return List */}
                <select className="form-select" onChange={(e) => {
                    // console.log(e.target.value);
                    const c = content?.find((x) => x.url === e.target.value)
                    // window.location = e.target.value;
                    setSelected(c)
                    // console.log(selected)
                }}>
                    <option>{year}</option>
                    {
                        processing ? <Spinner animation="border" variant="success" /> : content.map((data, index) => {
                            return (
                                <option key={index} value={data.url} className="form-select"
                                >{data.text}</option>
                            )
                        })
                    }
                </select>
            </div>
            {yearsWithAddedOnFiles.includes(year) ?  <>
                <br />

                <b>Additional Files: </b>

                <Links linkTypeID={840} /> 




                       
                <br/>
            </> : null}
        </>
    )
};


export default WIDScrollDown;
